/* PRJ-31 form configs — one entry per form. Adding a form = adding an entry here + a Shopify page.
 * Content faithfully migrated from the 4 live Typeforms (pulled 2026-07-02).
 * Search "TODO(" for the placeholder content owners still need to fill.
 */
(function () {
  'use strict';

  /* Shared post-purchase survey — identical across stores except the brand name.
   * Branching carried from Typeform: improve shows only if satisfaction <= 3;
   * email skipped entirely if UGC answer is "No, not interested".
   * TODO(JESSICA): email standardized to required on ALL stores (Typeform had APV required, EQM/GPV optional). */
  function survey(id, brand) {
    return {
      id: id,
      title: brand + ' Post-Purchase Survey',
      submitLabel: 'Send',
      thankYouTitle: 'Thank you!',
      /* TODO(MELVIE): UGC follow-up copy — align this thank-you line + the gift/discount wording
         with the Klaviyo follow-up flow so the form promise matches the email they receive. */
      thankYou: 'Your feedback genuinely helps us improve. If you opted into our UGC program, keep an eye on your inbox!',
      fields: [
        { key: 'satisfaction', type: 'rating', scale: 5, required: true,
          label: 'How satisfied are you with your recent purchase from ' + brand + '?',
          help: '1 = Very Dissatisfied, 5 = Very Satisfied' },
        { key: 'improve', type: 'longtext', label: 'What could we improve?',
          showIf: 'satisfaction <= 3' },
        { key: 'heard_about', type: 'select',
          label: 'How did you first hear about ' + brand + '?',
          options: ['Google / search engine', 'Facebook or Instagram', 'TikTok', 'YouTube',
                    'Recommended by a friend or family', 'Other'] },
        { key: 'checkout_reason', type: 'select',
          label: 'Was there anything that almost stopped you from completing your purchase?',
          options: ['No, checkout was smooth', 'The price felt high', 'Shipping cost or delivery time',
                    'I wanted more reviews or product information', 'The website was hard to navigate',
                    'The checkout process was confusing'] },
        { key: 'like_most', type: 'select',
          label: 'What do you like most about the product you purchased?',
          options: ['Durability & Quality', 'Performance & Effectiveness', 'Price & Value', 'Ease of Use'] },
        { key: 'ugc_interest', type: 'select', required: true,
          label: 'Would you be interested in sharing a photo or video of your purchase for a small gift or discount?',
          options: ["Yes! I'd love to share my experience", 'Maybe, tell me more', 'No, not interested'] },
        { key: 'email', type: 'email', required: true,
          label: "What's your email address?",
          help: "We'll use it to follow up with you regarding our UGC program.",
          showIf: "ugc_interest != 'No, not interested'" },
        /* Asked ONLY when the post-purchase link did not already carry ?order=,
           so anyone arriving from the email never sees it. */
        { key: 'order', type: 'shorttext', skipIfContext: 'order',
          label: 'What is your order number?',
          help: 'Optional. It lets us match your feedback to your order.' }
      ]
    };
  }

  window.MX_FORM_CONFIGS = {
    'survey-apv': survey('survey-apv', 'Aqua Pro Vac'),
    'survey-eqm': survey('survey-eqm', 'EquipMaxx'),
    'survey-gpv': survey('survey-gpv', 'GutterProVac'),

    /* GPV Startup Marketing Form — collateral questionnaire (14 Typeform fields).
     * contact_info + address decomposed into grouped sub-fields (one screen each). */
    'gpv-startup-marketing': {
      id: 'gpv-startup-marketing',
      title: 'GPV Startup Marketing Form',
      submitLabel: 'Submit',
      thankYouTitle: 'All set!',
      thankYou: "Thanks — our team will start on your marketing materials and reach out if we need anything.",
      fields: [
        { key: 'order_number', type: 'shorttext', required: true,
          label: 'What is your order number?',
          help: 'You can find this in your invoice or shipping confirmation email.' },

        /* TODO(BIA/RENEE): ① real tile names (Typeform had "choice 1..5") ② confirm which tile is the
           "use my custom business colors" option — assumed tile 5; the custom_colors question keys off it.
           ③ rehost images: Typeform CDN URLs below still serve, but move them to Shopify Files
           (Content -> Files) and swap the URLs — they die if the Typeform account closes. */
        { key: 'design_choice', type: 'image-select', columns: 3, required: true,
          label: 'Would you like to choose one of our pre-made designs or provide your custom business colors?',
          help: 'Pick a pre-made template, or choose custom to use your business colors.',
          options: [
            { value: 'design-1',      label: 'TODO(BIA/RENEE): name design 1', image: 'https://images.typeform.com/images/vTY9bAuSeXkA' },
            { value: 'design-2',      label: 'TODO(BIA/RENEE): name design 2', image: 'https://images.typeform.com/images/uL4KSqv9GZSR' },
            { value: 'design-3',      label: 'TODO(BIA/RENEE): name design 3', image: 'https://images.typeform.com/images/6DLRYMZ3H98m' },
            { value: 'design-4',      label: 'TODO(BIA/RENEE): name design 4', image: 'https://images.typeform.com/images/RH53nRaKBAtd' },
            { value: 'custom-colors', label: 'TODO(BIA/RENEE): confirm this is the custom-colors tile', image: 'https://images.typeform.com/images/CTHaP5TXqfYH' }
          ] },

        { key: 'custom_colors', type: 'longtext',
          label: 'What custom colors would you like for your marketing materials?',
          help: 'Provide two hex color codes and note which is the main color and which is the accent (e.g., #FFFFFF for white).',
          showIf: "design_choice == 'custom-colors'" },

        { key: 'contact', type: 'group',
          label: 'Provide your contact details, including your company name.',
          inputs: [
            { key: 'first_name',   label: 'First name',   type: 'text',  required: true },
            { key: 'last_name',    label: 'Last name',    type: 'text',  required: true },
            { key: 'company_name', label: 'Company name', type: 'text',  required: true },
            { key: 'phone',        label: 'Phone number', type: 'tel' },
            { key: 'contact_email', label: 'Email',       type: 'email', required: true }
          ] },

        { key: 'address', type: 'group',
          label: 'What is your company address?',
          help: 'So customers know where to find you.',
          inputs: [
            { key: 'addr_line1', label: 'Address line 1', type: 'text', required: true },
            { key: 'addr_line2', label: 'Address line 2', type: 'text' },
            { key: 'addr_city',  label: 'City',           type: 'text', required: true },
            { key: 'addr_state', label: 'State / Province', type: 'text', required: true },
            { key: 'addr_zip',   label: 'ZIP / Postal code', type: 'text', required: true }
          ] },

        { key: 'company_website', type: 'url',
          label: 'What is your company website?',
          help: 'So customers can easily find you online.' },

        { key: 'logo', type: 'file', required: true, accept: '.png,.svg',
          label: 'Please provide your company logo.',
          help: 'A clear, high-quality image (at least 500x500px) in .png or .svg format with a transparent background.' },

        { key: 'brand_statements', type: 'longtext',
          label: 'Please provide your 3 main brand statements or service mottos.',
          help: 'Three short, impactful statements. Examples: "Clear Gutters, Safe Homes." / "Clean Gutters, Every Season." / "Reliable Gutter Care."' },

        { key: 'about_us', type: 'longtext',
          label: 'Please provide an "About Us" description for your company.',
          help: "A brief description highlighting your company's mission and values." },

        { key: 'why_choose', type: 'longtext',
          label: 'Why should customers choose your company?',
          help: 'A short explanation of what sets your company apart.' },

        { key: 'main_features', type: 'longtext',
          label: 'What are the 3 main features you give to your customers?',
          help: 'Examples: Expert technicians / High-quality service / Affordable prices' },

        { key: 'services', type: 'select', multiple: true, required: true,
          label: 'What services do you offer to your customers? (Select all that apply)',
          options: ['Softwash Roof Cleaning', 'Window Cleaning', 'Solar Panel Cleaning', 'Gutter Cleaning',
                    'Gutter Brightening', 'Hard Surface Cleaning', 'Pressure Washing', 'Lawn Care'] },

        { key: 'qr_link', type: 'url',
          label: 'What is your preferred link to generate into a QR code?',
          help: 'Your website, social media page, or any other link you want on your materials.' },

        { key: 'discounts', type: 'longtext',
          label: 'Do you offer any special discounts for new customers?',
          help: "If yes, we'll highlight them in your marketing materials." }
      ]
    }
  };
})();
